import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { IonItemSliding } from "@ionic/angular";
import { Bills } from "src/model/class/general classes/bill";
import { AlertService } from "src/service/alert.service";
import { SystemRouterService } from "src/service/system-router.service";
import { MomentFormats } from "src/model/class/general classes/moment-formats";

@Component({
    selector: "app-bill",
    templateUrl: "./bill-component.html",
    styleUrls: ["./bill-component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BillComponent implements OnInit {
  private _isSliding = false;

  public sizeIcon: number = 20;
  public dateTimeOutputFormat: string = "";
  public billDateOutputFormat: string = "";

  @Input() bill: Bills;
  @Input() ofDateLabel: string;
  @Input() periodFrom: string;
  @Input() toDateLabel: string;
  @Input() deleteBillConfirmTitle: string;
  @Input() deleteBillConfirmMsg: string;

  @Output() onDeleteBill = new EventEmitter<number>();
  @Output() checkIsSliding = new EventEmitter<boolean>();

  constructor(
    private _systemRouterService: SystemRouterService,
    private _alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.dateTimeOutputFormat = MomentFormats.MOMENT_DATETIME_DATE_EXTENDED;
    this.billDateOutputFormat =
      MomentFormats.MOMENT_DATETIME_FORMAT_DATE_YEAR;
  }

  /**
   * Amount of the bill as currency (locale of the browser)
   */
  public formatAmount(amount: number): string {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "EUR",
    }).format(amount);
  }

  /**
   *  Handle the event when the user slides and  clicks on the edit bill  button
   * @param item  IonItemSliding
   * @param idSelectedBill  id of the selected Bill
   */
  public onClickEditBill(item: IonItemSliding, idSelectedBill: number) {
    this._isSliding = false;
    this.checkIsSliding.emit(this._isSliding);
    this._systemRouterService.navigateBillsDetailsEdit(idSelectedBill);
    item?.close();
  }

  /**
   * Handle the event when the user slides and clicks on the delete bill button
   * @param item IonItemSliding
   * @param idSelectedBill id of the selected bill
   */
  public async onClickDeleteBill(
    item: IonItemSliding,
    idSelectedBill: number
  ): Promise<void> {
    this._isSliding = false;
    this.checkIsSliding.emit(this._isSliding);

    try {
      const alertResponse: boolean =
        await this._alertService.presentAlertConfirmOrDismiss(
          this.deleteBillConfirmTitle,
          "",
          this.deleteBillConfirmMsg
        );
      if (alertResponse) {
        this.onDeleteBill.emit(idSelectedBill);
      }
    } catch (error) {
      await this._alertService.presentAlertSomethingWrong();
    } finally {
      item?.close();
    }
  }
}
